/**
 * Fetches an image from `url` and returns only the Base64 string.
 * (CORS header required on cross-origin images.)
 */
export async function getBase64StringFromUrl(url: string): Promise<string> {
    const res = await fetch(url);
    if (!res.ok) {
        throw new Error(`Failed to fetch image: ${res.status} ${res.statusText}`);
    }
    const blob = await res.blob();
    return await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = () => {
            reader.abort();
            reject(new Error("Failed to read image blob"));
        };
        reader.onloadend = () => {
            const dataUrl = reader.result as string;
            // everything after the comma is the pure Base64 payload
            const base64 = dataUrl.split(",")[1];
            resolve(base64);
        };
        reader.readAsDataURL(blob);
    });
}